// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1aEdr","upload":"Small_upload__1jana","imageWrap":"Small_imageWrap__CdwlQ","removeBtn":"Small_removeBtn__387Ji"};